import {
  FETCH_PURCHASE_APPROVAL_ADMIN_LIST,
  RESET_PURCHASE_APPROVAL_ADMIN_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const purchaseApprovalAdminListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURCHASE_APPROVAL_ADMIN_LIST:
      return { list: action.payload, others: action.others };
    case RESET_PURCHASE_APPROVAL_ADMIN_LIST:
      return initialState;
    default:
      return state;
  }
};

export default purchaseApprovalAdminListReducer;
